export const INTERSTITIAL_CLASSES = [
    'triggerInterstitialModal',
    'interstitialModalThirdParty'
];

export const INTERSTITIAL_LABELS = {
    title: 'You Are About To Leave the Walt Disney World website',
    description: 'Once you leave the Walt Disney World website, different terms of use and privacy policy will apply.',
    button: {
        close: 'Close',
        continue: 'Continue'
    }
};
